<template>
    <v-row
        align="center"
        justify="center"
        class="sem-documentos"
    >
        <div class="text-center">
            <div class="d-flex flex-column">
                <v-icon class="icon-info">
                    fas fa-box-archive
                </v-icon>

                <p class="text-info">
                    Você não possui <b>anexos</b> adicionados
                    <br>
                    clique no botão para começar
                </p>
            </div>

            <botao-novo-documento @novoDocumento="novoDocumento"/>
        </div>
    </v-row>
</template>

<script>
    import BotaoNovoDocumento from '@/views/components/documento/BotaoNovoDocumento'

    export default {
        name: 'DocumentosVazio',

        components: {
            BotaoNovoDocumento
        },

        methods: {
            novoDocumento() {
                this.$emit('novoDocumento')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .sem-documentos
        min-height 58vh

    .icon-info
        color #777 !important
        font-size 35px
        margin-bottom 10px

    .text-info
        color #777 !important
        font-size 14px
</style>
